import { Popover } from "antd";
import { LuEllipsisVertical, LuPencil, LuTrash2 } from "react-icons/lu";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { AI_RESPONSE_COPY } from "./constants";

/**
 * Kebab (⋮) actions menu for a user's OWN custom Quick Tip / Tone (EAI-1497).
 * Click opens a small Popover with Edit / Delete rows.
 *
 * The Popover renders inside its trigger's parent (`getPopupContainer`) rather
 * than portaling to <body>, so its clicks stay within the Customize panel's
 * stop-propagation boundary and don't read as an outside-click that would
 * dismiss the panel popover.
 *
 * @param {{ onEdit: () => void, onDelete: () => void }} props
 */
export default function ItemActionsMenu({ onEdit, onDelete }) {
  const [open, setOpen] = useState(false);

  const rowClass =
    "flex items-center gap-2 px-2 py-1 text-[13px] leading-5 text-grey-700 bg-transparent border-0 cursor-pointer rounded hover:bg-grey-100 text-left whitespace-nowrap";

  const menu = (
    <div className="flex flex-col" onClick={e => e.stopPropagation()}>
      <button
        type="button"
        className={rowClass}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(false);
          onEdit();
        }}
      >
        <LuPencil className="text-[#1677FF]" /> {AI_RESPONSE_COPY.MENU_EDIT}
      </button>
      <button
        type="button"
        className={rowClass}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(false);
          onDelete();
        }}
      >
        <LuTrash2 className="text-[#FF4D4F]" /> {AI_RESPONSE_COPY.MENU_DELETE}
      </button>
    </div>
  );

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      trigger="click"
      placement="bottomRight"
      overlayInnerStyle={{ padding: 4, width: "max-content" }}
      getPopupContainer={node => node.parentNode}
      content={menu}
    >
      <button
        type="button"
        aria-label="More options"
        className="flex items-center justify-center w-5 h-5 bg-transparent border-0 cursor-pointer text-black hover:text-black font-bold"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <LuEllipsisVertical className="icon-color" />
      </button>
    </Popover>
  );
}

ItemActionsMenu.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
